export const SITE = {
  name: "AIM High",
  phone: "(908) 415-7371",
  phoneHref: "tel:+19084157371",
  phoneRaw: "+1-908-415-7371",
  email: "aimhighnewjersey@gmail.com",
  address: {
    street: "16 New Street",
    city: "Colts Neck",
    state: "NJ",
    zip: "07722",
    full: "16 New Street, Colts Neck, NJ 07722",
  },
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=16+New+Street%2C+Colts+Neck%2C+NJ+07722",
  mapEmbed:
    "https://www.google.com/maps?q=16+New+Street,+Colts+Neck,+NJ+07722&output=embed",
  hicNumber: "[HIC # TBD]",
  hours: "[HOURS TBD]",
  tagline:
    "Full-Service Exterior & General Contractor in Monmouth County, NJ.",
  geo: { lat: 40.2879, lng: -74.1793 },
  url: "https://aimhighnewjersey.com",
};

export const RESIDENTIAL_NAV = [
  { label: "Roofing", path: "/residential/roofing", icon: "RoofIcon" },
  { label: "Siding", path: "/residential/siding", icon: "Layers" },
  { label: "Gutters", path: "/residential/gutters", icon: "CloudRain" },
  { label: "Kitchen Renovations", path: "/residential/kitchen-remodeling", icon: "StoveIcon" },
  { label: "Bathroom Renovations", path: "/residential/bathroom-remodeling", icon: "Bath" },
  { label: "Basement Finishing", path: "/residential/basement-finishing", icon: "BasementIcon" },
];

export const COMMERCIAL_NAV = [
  { label: "General Maintenance", path: "/commercial/general-maintenance", icon: "Wrench" },
  { label: "Restaurant Build-Outs", path: "/commercial/restaurant-build-outs", icon: "UtensilsCrossed" },
  { label: "Retail & Storefronts", path: "/commercial/retail-storefronts", icon: "Store" },
];

export const TRUST_BADGES = [
  { icon: "ShieldCheck", label: "Licensed & Insured" },
  { icon: "BadgeCheck", label: "NJ HIC #[TBD]" },
  { icon: "Clock", label: "20+ Years" },
  { icon: "Hammer", label: "Former Union Carpenter" },
  { icon: "FileText", label: "Free Estimates" },
];

export const HOME_STATS = [
  { value: 20, suffix: "+", label: "Years Experience" },
  { value: 14, suffix: "", label: "Years in Business" },
  { value: 4, suffix: "", label: "NJ Counties Served" },
  { value: 100, suffix: "%", label: "Licensed & Insured" },
];

export const CLIENT_CONCERNS = [
  {
    worry: "Will the price change halfway through?",
    answer:
      "You get an honest quote upfront — if something unexpected comes up, we explain it and get your OK before touching it.",
  },
  {
    worry: "Will this drag on forever?",
    answer:
      "We keep your job on schedule and tell you exactly where we are, every step of the way.",
  },
  {
    worry: "Can I trust who's in my home?",
    answer:
      "Licensed, insured, and 20+ years of craftsmanship from a former union carpenter.",
  },
  {
    worry: "Do I need different contractors for different jobs?",
    answer: "One experienced crew for your home or your business.",
  },
];

export const PROMISES = [
  "Honest pricing, upfront",
  "Surprises explained before we act — never at the end",
  "Minimal change orders",
  "Your job kept on schedule",
];

// NOTE: Placeholder testimonials — replace with real client reviews when available.
export const TESTIMONIALS = [
  { quote: "They pulled our leaking roof, showed us the rot underneath before touching it, and had us watertight in two days. The price they quoted was the price we paid.", name: "Maria K.", town: "Holmdel, NJ", role: "Roof Replacement" },
  { quote: "Our kitchen came out better than we pictured. Every day the site was left clean, and they hit the schedule they promised. No surprise change orders.", name: "David R.", town: "Marlboro, NJ", role: "Kitchen Renovation" },
  { quote: "Finished the basement into a real family room. They handled the moisture issue first and explained everything as they went. Honest people.", name: "Jen P.", town: "Freehold, NJ", role: "Basement Finishing" },
  { quote: "New siding completely changed the look of the house — and the drafts are gone. Fair quote, no pressure, and they respected the property.", name: "Anthony M.", town: "Middletown, NJ", role: "Siding" },
  { quote: "I manage a gym and needed repairs done around our hours. They worked evenings, kept us open, and never left a mess for members to find.", name: "Priya S.", town: "Edison, NJ", role: "Commercial Maintenance" },
  { quote: "Our bathroom was dated and cramped. They reworked the layout and it feels twice the size now. Clean work, on time, and truly no surprises.", name: "Chris & Dana L.", town: "Manalapan, NJ", role: "Bathroom Renovation" },
  { quote: "Gutters used to overflow every storm and water pooled at the foundation. They resized everything and the basement's been dry ever since.", name: "Robert T.", town: "Wall, NJ", role: "Gutter Install" },
  { quote: "We opened our restaurant on schedule because they actually communicated. Passed inspection first time — the build was done right.", name: "Sofia G.", town: "Red Bank, NJ", role: "Restaurant Build-Out" },
  { quote: "Twenty-plus years of experience really shows. Quality craftsmanship, licensed and insured, and they stood behind every detail of the job.", name: "The Russo Family", town: "Colts Neck, NJ", role: "Roofing & Siding" },
];

export const AIM_STANDARD = [
  { k: "01", title: "The quote is the price.", body: "You approve a clear, itemized number before we start — and that's what you pay. No padded change orders, no creep." },
  { k: "02", title: "Surprises get a phone call.", body: "If something unexpected turns up behind a wall, you hear about it and sign off before we touch it. Never a shock at the end." },
  { k: "03", title: "We keep to the calendar.", body: "Your job gets a real schedule and steady updates. We keep the crew moving and tell you exactly where things stand." },
  { k: "04", title: "One crew, start to finish.", body: "The same experienced hands from the first walkthrough to the final punch list — for your home or your business." },
];

export const PROJECT_TYPES = [
  "Roofing",
  "Siding",
  "Gutters",
  "Kitchen",
  "Bathroom",
  "Basement",
  "Commercial Maintenance",
  "Restaurant Build-Out",
  "Retail-Storefront",
  "Other",
];

export const COUNTIES = ["Monmouth", "Union", "Middlesex", "Ocean", "NYC", "Other"];

export const BUDGETS = [
  "Under $5k",
  "$5–15k",
  "$15–40k",
  "$40–75k",
  "$75k+",
  "Not sure",
];
